import * as fromAuthEntitiesExternal from './external/entities-external.reducer';
import * as fromAuthEntitiesInternal from './internal/entities-internal.reducer';
import * as fromAuthEntitiesGlobal from './global/entities-global.reducer';

export const BackAuthEntitiesFeatureKey = 'entities';

export interface IBackAuthEntitiesState
{
    [fromAuthEntitiesExternal.BackAuthEntitiesExternalFeatureKey]: fromAuthEntitiesExternal.IBackAuthEntitiesExternalState;
    [fromAuthEntitiesInternal.BackAuthEntitiesInternalFeatureKey]: fromAuthEntitiesInternal.IBackAuthEntitiesInternalState;
    [fromAuthEntitiesGlobal.BackAuthEntitiesGlobalFeatureKey]: fromAuthEntitiesGlobal.IBackAuthEntitiesGlobalState;
}
export const BackAuthEntitiesInitialState: IBackAuthEntitiesState =
{
    [fromAuthEntitiesExternal.BackAuthEntitiesExternalFeatureKey]: fromAuthEntitiesExternal.BackAuthEntitiesExternalInitialState,
    [fromAuthEntitiesInternal.BackAuthEntitiesInternalFeatureKey]: fromAuthEntitiesInternal.BackAuthEntitiesInternalInitialState,
    [fromAuthEntitiesGlobal.BackAuthEntitiesGlobalFeatureKey]: fromAuthEntitiesGlobal.BackAuthEntitiesGlobalInitialState
};
